import styled, { keyframes } from 'styled-components';
import { SM_FONT_SIZE } from '../Common/StyleElement';

const fadeIn = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`;

export const TooltipWrapper = styled.div`
    position: relative;
    display: inline-flex;
    user-select: none;
    margin: 0 10px;
    -webkit-tap-highlight-color: transparent;
`

export const TooltipContent = styled.div`
    position: absolute;
    padding: 12px;
    font-size: ${SM_FONT_SIZE};
    line-height: 1.5;
    font-weight: 400;
    cursor: default;
    border-radius: 10px;
    min-width: 300px;
    background-color: rgb(230, 230, 230);
    animation: ${fadeIn} ease-in-out 0.65s;
    top: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
`

export const TooltipArrow = styled.span`
    position: absolute;
    width: 0;
    height: 0;
    top: -10px;
    left: calc(50% - 10px);
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgb(230, 230, 230);
    border-left: 10px solid transparent;
`

export const TooltipContentSlim = styled.div`
    position: absolute;
    padding: 10px;
  
    //export const SM_FONT_SIZE = "0.875rem";
    font-size: 0.6rem;
    line-height: 1.5;
    font-weight: 400;
    cursor: default;
    border-radius: 10px;
    min-width: 300px;
    background-color: rgb(230, 230, 230);
    animation: ${fadeIn} ease-in-out 0.65s;
    top: calc(100% + 12px);
    left: 50%;
    transform: translateX(-70%);
  `

export const TooltipArrowSlim = styled.span`
    position: absolute;
    width: 0;
    height: 0;
    top: -10px;
    left: calc(70% - 10px);
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgb(230, 230, 230);
    border-left: 10px solid transparent;
`